var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeColored = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "red",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M33.698 13.13a3.58 3.58 0 0 0-2.518-2.518C28.944 10 20 10 20 10s-8.944 0-11.18.588A3.65 3.65 0 0 0 6.3 13.13c-.588 2.236-.588 6.873-.588 6.873s0 4.66.588 6.873a3.58 3.58 0 0 0 2.519 2.518c2.26.613 11.18.613 11.18.613s8.944 0 11.18-.589a3.58 3.58 0 0 0 2.518-2.518c.589-2.236.589-6.873.589-6.873s.023-4.66-.589-6.897"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "m17.152 24.287 7.438-4.284-7.438-4.284z"
})));
export default SvgYoutubeColored;